// @refresh reset
// engine.ts writes into this markup directly, so hot reloads must remount.
import { useEffect, useRef } from "react";
import HeroMarkup from "./HeroMarkup";
import { startHeroTest } from "./engine";
import "./herotest.css";

// The /herotest hero on the home page: nav, headline and the animated MacBook.
// Only the hero is rendered here; the engine skips the other /herotest sections.

const DM_SANS = "https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400..900&display=swap";
// warm the browser cache for the headline Vovy before the Rive player asks for it
const VIBING_RIV = "/animations/vibingvovy.riv";

export default function HomeHero() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // brand type (vovy-brand-kit): DM Sans for display; Inter is loaded site-wide
    const font = document.createElement("link");
    font.rel = "stylesheet";
    font.href = DM_SANS;
    document.head.appendChild(font);
    // prefetch the hero Vovy's .riv so he's on screen on first paint
    const riv = document.createElement("link");
    riv.rel = "preload";
    riv.as = "fetch";
    riv.href = VIBING_RIV;
    document.head.appendChild(riv);
    const stop = startHeroTest(rootRef.current!);

    // The page's flying VovyGuide rests just under the hero copy, which is the
    // top of the MacBook here. Hide him while he's over its screen, where the
    // demo's own cursor, Vovy and notch are the point.
    let guide: HTMLElement | null = null;
    const sync = () => {
      guide ??= document.querySelector<HTMLElement>(".pointer-events-none.fixed.inset-0.z-40");
      const body = guide?.firstElementChild?.getBoundingClientRect();
      const disp = rootRef.current?.querySelector(".display")?.getBoundingClientRect();
      if (!guide || !body || !disp) return;
      const over = body.bottom - body.height * 0.25 > disp.top && body.top < disp.bottom && body.right > disp.left && body.left < disp.right;
      // opacity, not visibility: the guide sets visibility inline on its child
      guide.style.opacity = over ? "0" : "";
    };
    const poll = setInterval(sync, 120);

    return () => {
      clearInterval(poll);
      if (guide) guide.style.opacity = "";
      stop();
      font.remove();
      riv.remove();
    };
  }, []);

  return (
    <div ref={rootRef}>
      <div className="herotest">
        <HeroMarkup links={[["#features", "How it works"], ["#pricing", "Pricing"], ["#faq", "FAQ"]]} placement="home" howHref="#features" />
      </div>
    </div>
  );
}
